import { memo } from "react";

import {
  ClipboardCheck as AllowlistIcon,
  CoinsFill as SpecificCurrencyIcon,
  HexagonFill as SpecificTokenIcon,
  TagFill as SpecificAttributeIcon,
  Grid as AnyTokenIcon,
  FarcasterIcon,
} from "@hl/base-components/lib/assets/icons.generated";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import {
  useFeatureFlags,
  FEATURE_FLAGS,
} from "@hl/shared-features/lib/features/auth/hooks";
import { Button, Grid, Menu, Text } from "@mantine/core";
import { IconChevronDown, IconCirclePlus } from "@tabler/icons";

import { Condition } from "apollo/graphql.generated";

import { useConditionModals } from "./condition-modals";

export type Props = {
  onAddCondition: (condition: Condition) => void;
  haveMarketingCondition?: boolean;
  isModal?: boolean;
};

const AddConditionMenu = ({ onAddCondition, isModal }: Props) => {
  const showGateByAttribute = useFeatureFlags("gateByTokenAttribute");
  const showGateByFarcaster = useFeatureFlags(
    FEATURE_FLAGS.GATE_BY_FARCASTER_FOLLOWERS
  );

  const {
    openFindTokenModal,
    openFindCollectionModal,
    openSetCurrencyModal,
    openFindAttributeModal,
    openSetAllowlistModal,
    openFarcasterModal,
  } = useConditionModals(onAddCondition, isModal);

  return (
    <Grid justify="flex-end" align="flex-end">
      <Grid.Col span="content">
        <Menu position="bottom-end">
          <Menu.Target>
            <Button
              color={SECONDARY_COLOR}
              leftIcon={<IconCirclePlus size={16} />}
              rightIcon={<IconChevronDown size={16} />}
            >
              <Text>Add condition</Text>
            </Button>
          </Menu.Target>

          <Menu.Dropdown maw={"100%"}>
            <Menu.Item
              icon={<AllowlistIcon />}
              onClick={() => openSetAllowlistModal()}
            >
              Is on an allowlist of wallet addresses
            </Menu.Item>
            <Menu.Item
              icon={<AnyTokenIcon />}
              onClick={() => openFindCollectionModal()}
            >
              Holds any token from a collection
            </Menu.Item>
            <Menu.Item
              icon={<SpecificTokenIcon />}
              onClick={() => openFindTokenModal()}
            >
              Holds a specific token from a collection
            </Menu.Item>
            {showGateByAttribute && (
              <Menu.Item
                icon={<SpecificAttributeIcon />}
                onClick={() => openFindAttributeModal()}
              >
                Holds a token with a specific attribute
              </Menu.Item>
            )}
            <Menu.Item
              icon={<SpecificCurrencyIcon />}
              onClick={() => openSetCurrencyModal()}
            >
              Holds a minimum amount of ETH, MATIC, or an ERC-20
            </Menu.Item>
            {showGateByFarcaster && (
              <Menu.Item
                icon={<FarcasterIcon width={24} height={24} />}
                onClick={() => openFarcasterModal()}
              >
                Farcaster follower of a specific user
              </Menu.Item>
            )}
          </Menu.Dropdown>
        </Menu>
      </Grid.Col>
    </Grid>
  );
};
export default memo(AddConditionMenu);
